import React from "react";
import SecondaryButton from "../../../../components/buttons/secondary-button";
import styles from "../index.module.scss";

const CreditProviderCard = ({
	provider,
	onEdit,
	onDelete,
	isCompanyAdmin,
	currentUserEmail,
}) => {
	const isGroupOne = provider.group === "Group 1";
	const shouldShowSubscriberRequired = isGroupOne
		? false
		: provider.group === "Group 2" &&
			!provider.hasSubscriberIdAtCompanyOrUserLevel;
	const isRemoveDisabled =
		isCompanyAdmin !== true &&
		!(
			provider.user_email &&
			currentUserEmail &&
			provider.user_email === currentUserEmail
		);

	return (
	<article className={styles.providerCard} aria-label={provider.name}>
		<span
			className={styles.statusDot}
			role="img"
			aria-label={provider.configured ? "Configured" : "Not configured"}
			data-configured={provider.configured}
		/>
		<div className={styles.providerDetails}>
			<h2 className={styles.providerName}>
				{provider.name}
				{shouldShowSubscriberRequired && (
					<span className={styles.subscriberRequired}>SUBSCRIBER ID REQUIRED</span>
				)}
			</h2>
			<div className={styles.credentials}>
				<span>
					Username:{" "}
					<span className={styles.maskedValue}>{provider.username}</span>
				</span>
				<span>
					Password:{" "}
					<span className={styles.maskedValue}>{provider.password}</span>
				</span>
				{String(provider.subscriberId ?? "").trim() && provider.setByAdmin && (
					<span className={styles.subscriberSetByAdmin}>
						Subscriber ID: <strong>Set by Admin</strong>
					</span>
				)}
			</div>
		</div>
		<div className={styles.actions}>
			<SecondaryButton
				text="Edit"
				onClick={onEdit}
				fontType="regular"
				extraClass={styles.actionButton}
				extraTextClass={styles.actionText}
			/>
			<SecondaryButton
				text="Remove"
				onClick={onDelete}
				disabled={isRemoveDisabled}
				fontType="regular"
				extraClass={`${styles.actionButton} ${styles.removeButton}`}
				extraTextClass={styles.actionText}
			/>
		</div>
	</article>
	);
};

export default CreditProviderCard;
